module.exports = __webpack_public_path__ + "assets/bfabb5a30b824de8462e82ffdf885b8b.mp3";